// For ImageSlider, TestimonialSlider and Image components.
// When columnCount > 1, divides the container width by the number of visible
// columns at the current breakpoint (mirrors GridColumn.View.svelte logic).
export const getWidthByScreenSize = (columnCount = 0) => {
    const screenWidth = window.innerWidth;

    // Container max-width from Limiter.svelte breakpoints:
    //   default: 448px (max-w-md), sm (640): 576px (max-w-xl),
    //   md (768): 768px (max-w-3xl), lg (1024): 896px (max-w-4xl)
    // GridRow columns use the desktop Limiter variant which scales further:
    //   md (768): 768px, lg (1024): 1024px, xl (1280): 1280px, 2xl (1536): 1536px
    let containerWidth: number;

    if (columnCount > 1) {
        // Columns use the desktop Limiter variant (max-w-screen-*)
        if (screenWidth >= 1536) containerWidth = 1536;
        else if (screenWidth >= 1280) containerWidth = 1280;
        else if (screenWidth >= 1024) containerWidth = 1024;
        else if (screenWidth >= 768) containerWidth = 768;
        else if (screenWidth >= 640) containerWidth = 576;
        else containerWidth = 448;
    } else {
        // Single-column images use the default Limiter (max-w-4xl = 896px)
        if (screenWidth >= 1024) containerWidth = 896;
        else if (screenWidth >= 768) containerWidth = 768;
        else if (screenWidth >= 640) containerWidth = 576;
        else containerWidth = 448;
    }

    if (columnCount <= 1) {
        return containerWidth;
    }

    // Determine how many columns are actually visible at the current breakpoint,
    // matching the grid classes in GridRow.View.svelte:
    //   < md (768): 1 col, md+: 2 cols, lg+ (1024): 3 cols (only if exactly 3), xl+ (1280): 4 cols (if >=4)
    let visibleColumns = 1;

    if (screenWidth >= 1280 && columnCount >= 4) visibleColumns = 4;
    else if (screenWidth >= 1024 && columnCount === 3) visibleColumns = 3;
    else if (screenWidth >= 768 && columnCount >= 2) visibleColumns = 2;

    return Math.ceil(containerWidth / visibleColumns);
};
